import { render, staticRenderFns } from "./especiepagamento.vue?vue&type=template&id=72526320&"
import script from "./especiepagamento.vue?vue&type=script&lang=js&"
export * from "./especiepagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports